// @flow

/**
 * Key for this feature.
 */
export const FEATURE_KEY = 'features/breakout-rooms';
